/**
 * Şirket PMS kütüphanesinin metinleri (M15f; ADR 0063). Ekran ve sekme adları ortağın menüsündeki
 * gibi İngilizce (`g11.jpeg`: Component Library, Job Library, Import / Export); Türkçe ikinci dil.
 */

export const pmsLibraryEn = {
  title: 'PMS Library',
  description:
    'Company library of systems, equipment items and maintenance jobs. Apply selected items to a vessel with its own tag, location, criticality and intervals.',
  stats: {
    systems: 'Systems',
    items: 'Equipment items',
    jobs: 'Maintenance jobs',
    approved: 'Approved intervals',
  },
  tabs: {
    components: 'Component Library',
    jobs: 'Job Library',
    importExport: 'Import / Export',
    applications: 'Vessel Applications',
  },
  actions: {
    apply: 'Apply to Vessel',
    edit: 'Edit',
    save: 'Save',
    cancel: 'Cancel',
    remove: 'Remove',
    preview: 'Preview',
    import: 'Import',
    loadTemplate: 'Load Felix template',
    previewTemplate: 'Preview template',
    export: 'Export to Excel',
    next: 'Next',
    back: 'Back',
    applyNow: 'Apply to vessel',
    send: 'Send to vessel',
    review: 'Review',
    accept: 'Accept and apply',
    reject: 'Reject',
    close: 'Close',
    selectAll: 'Select all on this page',
    add: 'Add',
    addSystem: 'Add System',
    addItem: 'Add Item',
    addJob: 'Add Job',
    addJobTo: 'Add job to {{code}}',
  },
  empty: {
    title: 'The PMS library is empty',
    description:
      'Load the Felix template (partner’s list of 22 systems, 252 equipment items and 863 jobs) or import your own Excel file.',
    items: 'No equipment items match the filters',
    jobs: 'No jobs match the filters',
    applications: 'No vessel applications yet',
  },
  error: 'The PMS library could not be loaded.',
  filters: {
    search: 'Search code, name or title…',
    allSystems: 'All systems',
    system: 'System',
    type: 'Job type',
    status: 'Status',
    interval: 'Interval',
    intervalAll: 'All',
    intervalSet: 'Set',
    intervalMissing: 'Missing',
    vessel: 'Vessel',
    allVessels: 'All vessels',
  },
  columns: {
    code: 'Item ID',
    subSystem: 'Sub-System',
    equipment: 'Equipment / Components',
    critical: 'Critical',
    jobs: 'Jobs',
    review: 'Review',
    jobCode: 'Job ID',
    item: 'Item',
    title: 'Job Title / PMS Activity',
    type: 'Type',
    interval: 'Interval',
    basis: 'Basis',
    department: 'Department',
    status: 'Status',
    actions: 'Actions',
    date: 'Date',
    vessel: 'Vessel',
    sentBy: 'Sent by',
    decided: 'Decided',
    note: 'Note / reason',
    select: 'Select',
    name: 'Name on vessel',
    tag: 'Equipment Tag',
    location: 'Location',
    serialNo: 'Serial No.',
    counter: 'Hours counter',
    every: 'Every',
    unit: 'Unit',
    hours: 'Running hours',
    baselineOn: 'Last done',
    baselineHours: 'Hours at last done',
    sheet: 'Sheet',
    row: 'Row',
    field: 'Field',
    problem: 'Problem',
  },
  showing: 'Showing {{from}}–{{to}} of {{total}}',
  itemsList: 'Equipment item list',
  jobsList: 'Maintenance job list',
  applicationsList: 'Vessel application list',
  systems: 'Systems',
  itemsTitle: 'Equipment items',
  jobsTitle: 'Maintenance jobs',
  suggested: 'Suggested',
  noInterval: 'Not set',
  unassigned: 'Assigned department',
  statuses: {
    draft: 'Draft – Review',
    approved: 'Approved',
    pending: 'Pending review',
    reviewed: 'Reviewed',
  },
  applicationStatuses: {
    pending: 'Pending on board',
    applied: 'Applied',
    rejected: 'Rejected',
  },
  units: {
    day_one: '{{count}} day',
    day_other: '{{count}} days',
    week_one: '{{count}} week',
    week_other: '{{count}} weeks',
    month_one: '{{count}} month',
    month_other: '{{count}} months',
    year_one: '{{count}} year',
    year_other: '{{count}} years',
    hours_one: '{{count}} h',
    hours_other: '{{count}} h',
  },
  unitNames: { day: 'Days', week: 'Weeks', month: 'Months', year: 'Years' },
  bases: {
    maker: 'Manufacturer',
    class: 'Class',
    experience: 'Experience',
    company: 'Company',
  },
  departments: {
    deck: 'Deck',
    engine: 'Engine',
    electrical: 'Electrical',
    navigation: 'Navigation',
    safety: 'Safety',
    accommodation: 'Accommodation',
    galley: 'Galley',
    other: 'Other',
  },
  workTypes: {
    Inspection: 'Inspection',
    Overhaul: 'Overhaul',
    Service: 'Maintenance',
    Cleaning: 'Cleaning',
    Replace: 'Replace',
    Test: 'Test',
    Calibration: 'Calibration',
    Lubrication: 'Lubrication',
    Repair: 'Repair',
    Modify: 'Modify',
    Adjust: 'Adjust',
    Refit: 'Refit',
    Check: 'Check',
    Combination: 'Combination',
    Other: 'Other',
  },
  itemForm: {
    title: 'Edit equipment item',
    subSystem: 'Sub-System / Vessel Type',
    name: 'Equipment / Components',
    components: 'Component / Maintainable Item',
    suggestedCritical: 'Suggested critical (decided per vessel)',
    maker: 'Manufacturer',
    model: 'Model',
    manualRef: 'Manufacturer Manual / Revision',
    notes: 'Notes',
    reviewStatus: 'Review status',
    removeTitle: 'Remove equipment item?',
    removeText:
      'The item and its {{count}} jobs are removed from the library. Vessels where it was applied keep their equipment.',
  },
  jobForm: {
    title: 'Edit maintenance job',
    titleField: 'Job Title / PMS Activity',
    workType: 'Job type',
    interval: 'Interval',
    every: 'Every',
    unit: 'Unit',
    hours: 'Running hours',
    basis: 'Interval basis',
    department: 'Responsible department',
    critical: 'Critical job',
    makerRecommendation: 'Manufacturer recommendation',
    makerInterval: 'Manufacturer interval',
    manualRef: 'Manual reference',
    status: 'Status',
    statusHint:
      'An approved job needs an interval and a basis. Approved jobs are preselected when applying to a vessel.',
    removeTitle: 'Remove job?',
    removeText: 'The job is removed from the library. Vessels where it was applied keep their job.',
  },
  add: {
    system: {
      title: 'Add system',
      code: 'System code',
      codeHint: 'Up to 8 characters, unique in the library. Suggested: the next number.',
      name: 'PMS Main System',
      remarks: 'Remarks',
      done: 'System {{code}} added.',
    },
    item: {
      title: 'Add equipment item',
      parent: 'System',
      parentPlaceholder: 'Select a system',
      code: 'Item ID',
      codeHint: 'Unique in the library. Suggested: system code and the next number.',
      done: 'Equipment item {{code}} added.',
    },
    job: {
      title: 'Add maintenance job',
      parent: 'Equipment item',
      parentPlaceholder: 'Select an equipment item',
      code: 'Job ID',
      codeHint: 'Unique in the library. Suggested: JOB-, item ID and the next number.',
      vesselHint:
        'Vessels where the item is already applied get the job through Apply to Vessel: select the item again and the missing jobs are added. A job without an interval is not applied.',
      done: 'Job {{code}} added.',
    },
  },
  importer: {
    title: 'Import from Excel',
    description:
      'The partner’s format: System Index, Master Equipment List and Maintenance Job Library sheets. Only missing codes are added; existing library entries are never overwritten.',
    file: 'Excel file (.xlsx, max 10 MB)',
    filePlaceholder: 'Choose a file',
    templateTitle: 'Felix template',
    templateText:
      'The partner’s PMS list: 22 systems, 252 equipment items and 863 proposed jobs. Jobs come as drafts without intervals: review them and set intervals before applying to vessels.',
    exportTitle: 'Export',
    exportText:
      'Download the library in the same format. The file can be filled in and imported again.',
    summary: 'Import summary',
    previewNote: 'Preview only — nothing has been written.',
    importedNote: 'Imported.',
    added: 'To add',
    addedDone: 'Added',
    unchanged: 'Already in library',
    differs: 'Different in library (kept)',
    deleted: 'Removed in library (not restored)',
    skippedRows: '{{count}} rows with errors are skipped.',
    errors: 'Row errors',
    warnings: 'Warnings',
    differsList: 'Codes that differ (library value kept): {{codes}}',
    confirmWithErrors: 'Import the valid rows and skip {{count}} rows with errors?',
    sheets: {
      systems: 'System Index',
      items: 'Master Equipment List',
      jobs: 'Maintenance Job Library',
    },
    kinds: { systems: 'Systems', items: 'Equipment items', jobs: 'Jobs' },
  },
  issues: {
    REQUIRED: 'Required value is empty.',
    TOO_LONG: 'Value is too long.',
    INVALID_CODE: 'Invalid code.',
    DUPLICATE_CODE: 'Code appears more than once in the file.',
    UNKNOWN_SYSTEM: 'System code is not in the file or the library.',
    UNKNOWN_ITEM: 'Equipment Item ID is not in the file or the library.',
    SYSTEM_MISMATCH: 'System code differs from the item’s system.',
    INVALID_JOB_TYPE: 'Job type must be Inspection, Test or Maintenance.',
    INVALID_INTERVAL: 'Interval is not recognised (e.g. “3 months”, “500 h”).',
    INVALID_DEPARTMENT: 'Department is not recognised; left unassigned.',
    INVALID_FLAG: 'Use Yes or No.',
    INVALID_STATUS: 'Status is not recognised.',
    VESSEL_SPECIFIC_IGNORED:
      'Installed, tag and location are vessel-specific and are not stored in the library.',
    APPROVAL_NEEDS_INTERVAL: 'Approval needs an interval and a basis; imported as draft.',
  },
  wizard: {
    title: 'Apply to Vessel',
    steps: {
      vessel: 'Vessel',
      equipment: 'Equipment',
      jobs: 'Jobs & intervals',
      review: 'Review',
    },
    vessel: 'Vessel',
    vesselPlaceholder: 'Select a vessel',
    note: 'Note for the vessel (optional)',
    vesselHint:
      'In the setup phase the office applies directly. On an activated vessel the selection is sent as a request; the Chief Engineer accepts or rejects it on board.',
    groupCode: 'Group code on vessel',
    selectedItems: '{{count}} items selected',
    selectedJobs: '{{count}} jobs selected',
    noItems: 'Select at least one equipment item.',
    jobsHint:
      'Approved jobs are preselected with the library interval. A job without an interval is not applied. Running-hours intervals need a counter and the last done date and hours.',
    noJobs: 'No jobs for the selected items.',
    reviewHint: 'Checked against the vessel’s current equipment tree.',
    modeApply: 'Setup phase: the office applies the equipment and jobs now.',
    modeSend:
      'Activated vessel: the request goes to the vessel; the Chief Engineer applies it on board.',
    modeQueue:
      'Activated vessel: the equipment and jobs go to the vessel as setup changes and are applied at its next sync, without acceptance on board. Follow them in Setup Changes.',
    summary: {
      groupsCreated: 'Groups to create',
      groupsExisting: 'Existing groups',
      itemsCreated: 'Equipment to create',
      itemsAdopted: 'Existing equipment to link',
      itemsExisting: 'Already applied',
      jobsCreated: 'Jobs to create',
      jobsExisting: 'Jobs already on vessel',
    },
    errorsTitle: 'Fix these before applying',
    noErrors: 'No problems found.',
    applied: 'Applied to the vessel.',
    sent: 'Sent to the vessel.',
    queued: '{{count}} setup changes sent to the vessel; applied at its next sync.',
  },
  applyErrors: {
    GROUP_CODE_IN_USE:
      'The group code is used by another node on the vessel. Change the group code.',
    EQUIPMENT_CODE_IN_USE: 'The equipment code is used elsewhere on the vessel. Change the code.',
    DUPLICATE_EQUIPMENT_TAG: 'The equipment tag is already used on the vessel.',
    JOB_CODE_IN_USE: 'The job code is already used on the vessel.',
    INTERVAL_REQUIRED: 'Set an interval: a job without an interval is not applied.',
    INTERVAL_BASIS_REQUIRED: 'Select the interval basis.',
    COUNTER_REQUIRED: 'A running-hours interval needs a counter: tick “Hours counter”.',
    BASELINE_HOURS_REQUIRED: 'Enter the last done date and hours.',
    BASELINE_DATE_REQUIRED: 'Enter the last done date.',
    FUTURE_DATE: 'The date cannot be in the future.',
  },
  requests: {
    banner_one: '{{count}} PMS library request from the office',
    banner_other: '{{count}} PMS library requests from the office',
    bannerText: 'Review the equipment and jobs the office selected for this vessel.',
    title: 'PMS library requests',
    sentBy: 'Sent by {{name}} on {{date}}',
    counts: '{{items}} equipment items, {{jobs}} jobs',
    items: 'Equipment',
    jobs: 'Jobs',
    reason: 'Reason for rejection',
    reasonHint: 'Required. The office sees the reason.',
    decided: 'Decided',
    invalid:
      'The request cannot be applied to the current equipment tree. Reject it with a reason so the office can correct it.',
    accepted: 'Applied on board.',
    rejected: 'Rejected.',
    noPermission: 'Only the Chief Engineer (equipment rights) can decide.',
  },
  errors: {
    FORBIDDEN: 'You do not have permission for this action.',
    SHEET_MISSING: 'A required sheet is missing: {{detail}}.',
    INVALID_HEADER: 'A required column is missing: {{detail}}.',
    INVALID_FILE: 'The file could not be read as an Excel workbook.',
    FILE_TOO_LARGE: 'The file is larger than 10 MB.',
    EMPTY_FILE: 'The file has no sheets.',
    LIBRARY_INTERVAL_REQUIRED: 'An approved job needs an interval and a basis.',
    INVALID_LIBRARY_ENTRY: 'Some values are not valid.',
    DUPLICATE_LIBRARY_CODE: 'The code is already used in the library.',
    UNKNOWN_SYSTEM: 'The system is not in the library.',
    UNKNOWN_ITEM: 'The equipment item is not in the library.',
    APPLICATION_HAS_ERRORS: 'The selection has problems; see the list.',
    APPLICATION_DECIDED: 'This request has already been decided.',
    REASON_REQUIRED: 'Write the reason.',
    ROW_VERSION_CONFLICT: 'Someone else changed this entry. Reload and try again.',
    NETWORK: 'No connection. Check the network and try again.',
    GENERIC: 'The operation failed ({{code}}).',
  },
};

export const pmsLibraryTr: typeof pmsLibraryEn = {
  title: 'PMS Kütüphanesi',
  description:
    'Şirketin sistem, ekipman kalemi ve bakım işi kütüphanesi. Seçilen kalemleri gemiye kendi etiketi, konumu, kritikliği ve aralıklarıyla uygulayın.',
  stats: {
    systems: 'Sistem',
    items: 'Ekipman kalemi',
    jobs: 'Bakım işi',
    approved: 'Onaylı aralık',
  },
  tabs: {
    components: 'Bileşen Kütüphanesi',
    jobs: 'İş Kütüphanesi',
    importExport: 'İçe / Dışa Aktar',
    applications: 'Gemi Uygulamaları',
  },
  actions: {
    apply: 'Gemiye Uygula',
    edit: 'Düzenle',
    save: 'Kaydet',
    cancel: 'Vazgeç',
    remove: 'Kaldır',
    preview: 'Önizle',
    import: 'İçe aktar',
    loadTemplate: 'Felix şablonunu yükle',
    previewTemplate: 'Şablonu önizle',
    export: 'Excel’e aktar',
    next: 'İleri',
    back: 'Geri',
    applyNow: 'Gemiye uygula',
    send: 'Gemiye gönder',
    review: 'İncele',
    accept: 'Kabul et ve uygula',
    reject: 'Reddet',
    close: 'Kapat',
    selectAll: 'Bu sayfadakilerin hepsini seç',
    add: 'Ekle',
    addSystem: 'Sistem ekle',
    addItem: 'Kalem ekle',
    addJob: 'İş ekle',
    addJobTo: '{{code}} kalemine iş ekle',
  },
  empty: {
    title: 'PMS kütüphanesi boş',
    description:
      'Felix şablonunu (ortağın 22 sistem, 252 ekipman kalemi ve 863 işlik listesi) yükleyin ya da kendi Excel dosyanızı içe aktarın.',
    items: 'Süzgece uyan ekipman kalemi yok',
    jobs: 'Süzgece uyan iş yok',
    applications: 'Henüz gemi uygulaması yok',
  },
  error: 'PMS kütüphanesi yüklenemedi.',
  filters: {
    search: 'Kod, ad ya da başlık ara…',
    allSystems: 'Bütün sistemler',
    system: 'Sistem',
    type: 'İş türü',
    status: 'Durum',
    interval: 'Aralık',
    intervalAll: 'Hepsi',
    intervalSet: 'Var',
    intervalMissing: 'Yok',
    vessel: 'Gemi',
    allVessels: 'Bütün gemiler',
  },
  columns: {
    code: 'Kalem No',
    subSystem: 'Alt Sistem',
    equipment: 'Ekipman / Bileşenler',
    critical: 'Kritik',
    jobs: 'İş',
    review: 'İnceleme',
    jobCode: 'İş No',
    item: 'Kalem',
    title: 'İş Başlığı / PMS Faaliyeti',
    type: 'Tür',
    interval: 'Aralık',
    basis: 'Dayanak',
    department: 'Departman',
    status: 'Durum',
    actions: 'İşlemler',
    date: 'Tarih',
    vessel: 'Gemi',
    sentBy: 'Gönderen',
    decided: 'Karar',
    note: 'Not / gerekçe',
    select: 'Seç',
    name: 'Gemideki adı',
    tag: 'Ekipman Etiketi',
    location: 'Konum',
    serialNo: 'Seri No',
    counter: 'Saat sayacı',
    every: 'Her',
    unit: 'Birim',
    hours: 'Çalışma saati',
    baselineOn: 'Son yapılış',
    baselineHours: 'Son yapılıştaki saat',
    sheet: 'Sayfa',
    row: 'Satır',
    field: 'Alan',
    problem: 'Sorun',
  },
  showing: '{{total}} kayıttan {{from}}–{{to}}',
  itemsList: 'Ekipman kalemi listesi',
  jobsList: 'Bakım işi listesi',
  applicationsList: 'Gemi uygulaması listesi',
  systems: 'Sistemler',
  itemsTitle: 'Ekipman kalemleri',
  jobsTitle: 'Bakım işleri',
  suggested: 'Önerilen',
  noInterval: 'Girilmedi',
  unassigned: 'Atanacak departman',
  statuses: {
    draft: 'Taslak – İnceleme',
    approved: 'Onaylı',
    pending: 'İnceleme bekliyor',
    reviewed: 'İncelendi',
  },
  applicationStatuses: {
    pending: 'Gemide bekliyor',
    applied: 'Uygulandı',
    rejected: 'Reddedildi',
  },
  units: {
    day_one: '{{count}} gün',
    day_other: '{{count}} gün',
    week_one: '{{count}} hafta',
    week_other: '{{count}} hafta',
    month_one: '{{count}} ay',
    month_other: '{{count}} ay',
    year_one: '{{count}} yıl',
    year_other: '{{count}} yıl',
    hours_one: '{{count}} sa',
    hours_other: '{{count}} sa',
  },
  unitNames: { day: 'Gün', week: 'Hafta', month: 'Ay', year: 'Yıl' },
  bases: {
    maker: 'Üretici',
    class: 'Klas',
    experience: 'Deneyim',
    company: 'Şirket',
  },
  departments: {
    deck: 'Güverte',
    engine: 'Makine',
    electrical: 'Elektrik',
    navigation: 'Seyir',
    safety: 'Emniyet',
    accommodation: 'Yaşam mahalli',
    galley: 'Kuzine',
    other: 'Diğer',
  },
  workTypes: {
    Inspection: 'Muayene',
    Overhaul: 'Revizyon',
    Service: 'Bakım',
    Cleaning: 'Temizlik',
    Replace: 'Değişim',
    Test: 'Test',
    Calibration: 'Kalibrasyon',
    Lubrication: 'Yağlama',
    Repair: 'Onarım',
    Modify: 'Tadilat',
    Adjust: 'Ayar',
    Refit: 'Yeniden takma',
    Check: 'Kontrol',
    Combination: 'Birleşik',
    Other: 'Diğer',
  },
  itemForm: {
    title: 'Ekipman kalemini düzenle',
    subSystem: 'Alt Sistem / Gemi Tipi',
    name: 'Ekipman / Bileşenler',
    components: 'Bileşen / Bakımı Yapılan Kalem',
    suggestedCritical: 'Önerilen kritik (gemide kesinleşir)',
    maker: 'Üretici',
    model: 'Model',
    manualRef: 'Üretici Kılavuzu / Revizyon',
    notes: 'Notlar',
    reviewStatus: 'İnceleme durumu',
    removeTitle: 'Ekipman kalemi kaldırılsın mı?',
    removeText:
      'Kalem ve {{count}} işi kütüphaneden kaldırılır. Uygulandığı gemilerin ekipmanı yerinde kalır.',
  },
  jobForm: {
    title: 'Bakım işini düzenle',
    titleField: 'İş Başlığı / PMS Faaliyeti',
    workType: 'İş türü',
    interval: 'Aralık',
    every: 'Her',
    unit: 'Birim',
    hours: 'Çalışma saati',
    basis: 'Aralığın dayanağı',
    department: 'Sorumlu departman',
    critical: 'Kritik iş',
    makerRecommendation: 'Üretici önerisi',
    makerInterval: 'Üretici aralığı',
    manualRef: 'Kılavuz referansı',
    status: 'Durum',
    statusHint: 'Onaylı iş aralık ve dayanak ister. Gemiye uygularken onaylı işler seçili gelir.',
    removeTitle: 'İş kaldırılsın mı?',
    removeText: 'İş kütüphaneden kaldırılır. Uygulandığı gemilerin işi yerinde kalır.',
  },
  add: {
    system: {
      title: 'Sistem ekle',
      code: 'Sistem kodu',
      codeHint: 'En çok 8 karakter, kütüphanede tekil. Öneri: sıradaki numara.',
      name: 'PMS ana sistemi',
      remarks: 'Açıklama',
      done: '{{code}} sistemi eklendi.',
    },
    item: {
      title: 'Ekipman kalemi ekle',
      parent: 'Sistem',
      parentPlaceholder: 'Sistem seçin',
      code: 'Kalem kodu',
      codeHint: 'Kütüphanede tekil. Öneri: sistem kodu ve sıradaki numara.',
      done: '{{code}} ekipman kalemi eklendi.',
    },
    job: {
      title: 'Bakım işi ekle',
      parent: 'Ekipman kalemi',
      parentPlaceholder: 'Ekipman kalemi seçin',
      code: 'İş kodu',
      codeHint: 'Kütüphanede tekil. Öneri: JOB-, kalem kodu ve sıradaki numara.',
      vesselHint:
        'Kalemin uygulandığı gemilere iş, Apply to Vessel ile iner: kalemi yeniden seçin, eksik işler eklenir. Aralıksız iş gemiye inmez.',
      done: '{{code}} işi eklendi.',
    },
  },
  importer: {
    title: 'Excel’den içe aktar',
    description:
      'Ortağın biçimi: System Index, Master Equipment List ve Maintenance Job Library sayfaları. Yalnız eksik kodlar eklenir; kütüphanedeki kayıtlar hiçbir zaman ezilmez.',
    file: 'Excel dosyası (.xlsx, en çok 10 MB)',
    filePlaceholder: 'Dosya seçin',
    templateTitle: 'Felix şablonu',
    templateText:
      'Ortağın PMS listesi: 22 sistem, 252 ekipman kalemi ve 863 önerilen iş. İşler aralıksız taslak olarak gelir: gemilere uygulamadan önce inceleyip aralıklarını girin.',
    exportTitle: 'Dışa aktar',
    exportText: 'Kütüphaneyi aynı biçimde indirin. Dosya doldurulup yeniden içe aktarılabilir.',
    summary: 'İçe aktarma özeti',
    previewNote: 'Yalnız önizleme — hiçbir şey yazılmadı.',
    importedNote: 'İçe aktarıldı.',
    added: 'Eklenecek',
    addedDone: 'Eklendi',
    unchanged: 'Kütüphanede var',
    differs: 'Kütüphanede farklı (korunur)',
    deleted: 'Kütüphanede kaldırılmış (geri gelmez)',
    skippedRows: 'Hatalı {{count}} satır atlanır.',
    errors: 'Satır hataları',
    warnings: 'Uyarılar',
    differsList: 'Farklı kodlar (kütüphanedeki değer korunur): {{codes}}',
    confirmWithErrors: 'Geçerli satırlar içe aktarılsın, hatalı {{count}} satır atlansın mı?',
    sheets: {
      systems: 'System Index',
      items: 'Master Equipment List',
      jobs: 'Maintenance Job Library',
    },
    kinds: { systems: 'Sistemler', items: 'Ekipman kalemleri', jobs: 'İşler' },
  },
  issues: {
    REQUIRED: 'Zorunlu değer boş.',
    TOO_LONG: 'Değer çok uzun.',
    INVALID_CODE: 'Geçersiz kod.',
    DUPLICATE_CODE: 'Kod dosyada birden çok kez geçiyor.',
    UNKNOWN_SYSTEM: 'Sistem kodu dosyada da kütüphanede de yok.',
    UNKNOWN_ITEM: 'Ekipman kalem numarası dosyada da kütüphanede de yok.',
    SYSTEM_MISMATCH: 'Sistem kodu kalemin sisteminden farklı.',
    INVALID_JOB_TYPE: 'İş türü Inspection, Test ya da Maintenance olmalı.',
    INVALID_INTERVAL: 'Aralık tanınmadı (ör. “3 months”, “500 h”).',
    INVALID_DEPARTMENT: 'Departman tanınmadı; atanmamış bırakıldı.',
    INVALID_FLAG: 'Yes ya da No yazın.',
    INVALID_STATUS: 'Durum tanınmadı.',
    VESSEL_SPECIFIC_IGNORED: 'Installed, etiket ve konum gemiye özeldir; kütüphaneye yazılmaz.',
    APPROVAL_NEEDS_INTERVAL: 'Onay aralık ve dayanak ister; taslak olarak alındı.',
  },
  wizard: {
    title: 'Gemiye Uygula',
    steps: {
      vessel: 'Gemi',
      equipment: 'Ekipman',
      jobs: 'İşler ve aralıklar',
      review: 'İnceleme',
    },
    vessel: 'Gemi',
    vesselPlaceholder: 'Gemi seçin',
    note: 'Gemiye not (isteğe bağlı)',
    vesselHint:
      'Kurulum devrinde ofis doğrudan uygular. Etkinleşmiş gemide seçim talep olarak gider; başmühendis gemide kabul ya da reddeder.',
    groupCode: 'Gemideki grup kodu',
    selectedItems: '{{count}} kalem seçili',
    selectedJobs: '{{count}} iş seçili',
    noItems: 'En az bir ekipman kalemi seçin.',
    jobsHint:
      'Onaylı işler kütüphane aralığıyla seçili gelir. Aralığı olmayan iş uygulanmaz. Çalışma saati aralığı sayaç ve son yapılış günü ile saatini ister.',
    noJobs: 'Seçilen kalemlerin işi yok.',
    reviewHint: 'Geminin güncel ekipman ağacına göre denetlendi.',
    modeApply: 'Kurulum devri: ofis ekipmanı ve işleri şimdi uygular.',
    modeSend: 'Etkinleşmiş gemi: talep gemiye gider; başmühendis gemide uygular.',
    modeQueue:
      'Etkinleşmiş gemi: ekipman ve işler kurulum değişikliği olarak gemiye gider, gemide kabul beklemeden sonraki senkronda uygulanır. Kurulum Değişiklikleri listesinden izleyin.',
    summary: {
      groupsCreated: 'Oluşturulacak grup',
      groupsExisting: 'Var olan grup',
      itemsCreated: 'Oluşturulacak ekipman',
      itemsAdopted: 'Bağlanacak var olan ekipman',
      itemsExisting: 'Zaten uygulanmış',
      jobsCreated: 'Oluşturulacak iş',
      jobsExisting: 'Gemide var olan iş',
    },
    errorsTitle: 'Uygulamadan önce düzeltin',
    noErrors: 'Sorun bulunmadı.',
    applied: 'Gemiye uygulandı.',
    sent: 'Gemiye gönderildi.',
    queued: '{{count}} kurulum değişikliği gemiye gönderildi; sonraki senkronda uygulanır.',
  },
  applyErrors: {
    GROUP_CODE_IN_USE: 'Grup kodu gemide başka bir düğümde kullanılıyor. Grup kodunu değiştirin.',
    EQUIPMENT_CODE_IN_USE: 'Ekipman kodu gemide başka yerde kullanılıyor. Kodu değiştirin.',
    DUPLICATE_EQUIPMENT_TAG: 'Ekipman etiketi gemide zaten kullanılıyor.',
    JOB_CODE_IN_USE: 'İş kodu gemide zaten kullanılıyor.',
    INTERVAL_REQUIRED: 'Aralık girin: aralığı olmayan iş uygulanmaz.',
    INTERVAL_BASIS_REQUIRED: 'Aralığın dayanağını seçin.',
    COUNTER_REQUIRED: 'Çalışma saati aralığı sayaç ister: “Saat sayacı”nı işaretleyin.',
    BASELINE_HOURS_REQUIRED: 'Son yapılış gününü ve saatini girin.',
    BASELINE_DATE_REQUIRED: 'Son yapılış gününü girin.',
    FUTURE_DATE: 'Tarih gelecekte olamaz.',
  },
  requests: {
    banner_one: 'Ofisten {{count}} PMS kütüphanesi talebi',
    banner_other: 'Ofisten {{count}} PMS kütüphanesi talebi',
    bannerText: 'Ofisin bu gemi için seçtiği ekipmanı ve işleri inceleyin.',
    title: 'PMS kütüphanesi talepleri',
    sentBy: '{{name}} gönderdi, {{date}}',
    counts: '{{items}} ekipman kalemi, {{jobs}} iş',
    items: 'Ekipman',
    jobs: 'İşler',
    reason: 'Ret gerekçesi',
    reasonHint: 'Zorunlu. Ofis gerekçeyi görür.',
    decided: 'Karar',
    invalid:
      'Talep güncel ekipman ağacına uygulanamıyor. Ofis düzeltebilsin diye gerekçeyle reddedin.',
    accepted: 'Gemide uygulandı.',
    rejected: 'Reddedildi.',
    noPermission: 'Yalnız başmühendis (ekipman yetkisi) karar verebilir.',
  },
  errors: {
    FORBIDDEN: 'Bu işlem için yetkiniz yok.',
    SHEET_MISSING: 'Gerekli sayfa yok: {{detail}}.',
    INVALID_HEADER: 'Gerekli sütun yok: {{detail}}.',
    INVALID_FILE: 'Dosya Excel çalışma kitabı olarak okunamadı.',
    FILE_TOO_LARGE: 'Dosya 10 MB’tan büyük.',
    EMPTY_FILE: 'Dosyada sayfa yok.',
    LIBRARY_INTERVAL_REQUIRED: 'Onaylı iş aralık ve dayanak ister.',
    INVALID_LIBRARY_ENTRY: 'Bazı değerler geçerli değil.',
    DUPLICATE_LIBRARY_CODE: 'Kod kütüphanede zaten kullanılıyor.',
    UNKNOWN_SYSTEM: 'Sistem kütüphanede yok.',
    UNKNOWN_ITEM: 'Ekipman kalemi kütüphanede yok.',
    APPLICATION_HAS_ERRORS: 'Seçimde sorunlar var; listeye bakın.',
    APPLICATION_DECIDED: 'Bu talep için karar zaten verildi.',
    REASON_REQUIRED: 'Gerekçeyi yazın.',
    ROW_VERSION_CONFLICT: 'Bu kaydı başkası değiştirdi. Yenileyip yeniden deneyin.',
    NETWORK: 'Bağlantı yok. Ağı denetleyip yeniden deneyin.',
    GENERIC: 'İşlem yapılamadı ({{code}}).',
  },
};
